import { useAuth } from '@/context/SupabaseAuthContext';
import { UserRole } from '@/types/userRole';

/**
 * Centralized role access. Reads role from the auth context (which itself
 * pulls the authoritative role from public.user_roles via get_primary_role).
 * Do NOT read role from profiles anywhere else in the app.
 */
export function useUserRole() {
  const { user, profile, loading } = useAuth();
  const role = (profile?.role as UserRole | undefined) ?? undefined;

  const dashboardPath = (() => {
    switch (role) {
      case 'admin':
      case 'manager':
        return '/admin/dashboard';
      case 'superadmin':
        return '/super-admin/dashboard';
      case 'masterAdmin':
        return '/master/dashboard';
      case 'business':
        return '/business/dashboard';
      case 'reseller':
        return '/reseller/dashboard';
      case 'user':
        return '/user/dashboard';
      default:
        return '/dashboard';
    }
  })();

  return {
    role,
    loading,
    isAuthenticated: !!user,
    isMasterAdmin: role === 'masterAdmin',
    isSuperAdmin: role === 'superadmin',
    isAdmin: role === 'admin',
    isReseller: role === 'reseller',
    isBusiness: role === 'business',
    isUser: role === 'user',
    isAdminOrAbove:
      role === 'admin' || role === 'superadmin' || role === 'masterAdmin',
    hasRole: (r: UserRole) => role === r,
    dashboardPath,
  };
}
